import React from 'react';
import { Navigate } from 'react-router-dom';

const PrivateRoute = ({ element, requiredRole }) => {
  const isAuthenticated = localStorage.getItem('token') || sessionStorage.getItem('token');
  const userRole = localStorage.getItem('role'); // Ensure you store the user's role
  
  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  if (requiredRole && userRole !== requiredRole) {
    return <Navigate to="/login" />;
  }

  return element; // Return the element directly
};

export default PrivateRoute;